import React, {
  useContext,
  useEffect,
  useState
} from 'react';

import PropTypes from 'prop-types';

import { useSalesPackages } from 'src/Hooks/useDealGrid';

import {
  Checkbox,
} from 'src/Components/Common';

import {
  SalesContext
} from 'src/Context/SalesContext';

import {
  ChevronRight,
  CloseIcon,
  SideDrawerBackIcon
} from '../Svg';

import './SideDrawer.css';

const SideDrawer = ({ isOpen, onClose, defaultFilter}) => {

  const salesContext = useContext(SalesContext);

  const filters = ['Contract length', 'Download speed', 'Promotions'];
  const [filter, selectedFilter] = useState(null)

  const {
    handleTermCheckboxChange,
    handlePromotionsCheckboxChange,
    handleSpeedCheckboxChange,
    clearFilters,
    contractTerms
  } = useSalesPackages();

  const selectFilterClick = (e) => {
    selectedFilter(e);
  };

  const navigateBack = () => {
    selectedFilter(null)
  }

  const content = (filter) => {

    switch (filter) {
      case 'Promotions':
        return (
          <div className='drawer-filters-promotions-container'>
            <Checkbox
              label="Show promotions only"
              checked={salesContext?.filters?.onPromotion}
              onChange={handlePromotionsCheckboxChange}
              value={salesContext?.filters?.onPromotion}
            />
            <hr style={{ width: '100%' }} />
          </div>
        );

      case 'Contract length':
        return (
          <div className='drawer-filters-main-contract-container'>
            {contractTerms?.map((term, index) => (
              <div key={index}
                className='drawer-filters-contract-container'>

                <Checkbox
                  key={index}
                  label={term === 'Month to Month' ? 'Month-to-month' : `${term.toLowerCase()} contract`}
                  checked={salesContext.selectedContractTerm === term}
                  onChange={() => handleTermCheckboxChange(term)}
                  value={!!salesContext.selectedContractTerm}
                  isRadio={true}
                />
                <hr style={{ width: '100%' }} />

              </div>
            ))
            }
          </div>
        );

      case 'Download speed':
        return (
          <div className='drawer-filters-main-speed-container'>
            {salesContext.filters?.downloadSpeed?.map((speed, index) => (

              <div
                key={index}
                className='drawer-filters-speed-container'>

                <Checkbox
                  key={index}
                  label={speed}
                  checked={salesContext.filters?.selectedSpeeds?.includes(speed)}
                  onChange={() => handleSpeedCheckboxChange(speed)}
                  automatioIdAttr={`Speed_${index}`}
                  value={salesContext.filters?.selectedSpeeds?.includes(speed)}
                />
                <hr style={{ width: '100%' }} />

              </div>
            ))}
          </div>
        );

      default:
        return <div></div>;
    }
  };

  useEffect(() => {

    if(!isOpen){
      selectedFilter(null)
    }

    if(defaultFilter){
      selectedFilter('Contract length')
    }
    else{
      selectedFilter(null)
    }

  }, [isOpen, defaultFilter]);

  return (
    <>
      {isOpen && (
        <div className="drawer-overlay">
          <div
            className="drawer"
            onClick={(e) => e.stopPropagation()}
          >
            <div className='drawer-controls'>
              <div
                className='drawer-controls-text'
                onClick={navigateBack}
              >
                {filter
                  ? <div className='nav-controls'><SideDrawerBackIcon/> {filter}</div>
                  : 'Filters'
                }

              </div>
              <div onClick={onClose}><CloseIcon /></div>
            </div>

            {!filter && <div>
              {filters.map((filter, index) => (
                <div
                  className='drawer-filters-main-container'
                  key={index}
                  onClick={() => selectFilterClick(filter)}>

                  <div className='drawer-filters-container'>
                    <div className='drawer-filters'>{filter}</div>
                    <div><ChevronRight /></div>
                  </div>

                  <hr style={{ width: '100%', margin: '0px' }} />
                </div>
              ))}
            </div>
            }

            {isOpen && filter &&

              <div
                className='drawer-filters-render-container'>
                {content(filter)}

                <div className='btn-container'>
                  <button className='clear-all-btn' onClick={clearFilters}> Clear all</button>
                  <button className='results-btn' onClick={onClose}> See results</button>
                </div>
              </div>
            }

          </div>
        </div>
      )}
    </>
  );
};

SideDrawer.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  filter: PropTypes.string,
  defaultFilter: PropTypes.bool
};

export default SideDrawer;